import React from "react";
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQ = () => {
    const faqs = [
        {
            q: "How to become a Channel Partner?",
            a: "Kindly contact us at 9220638055 for partnership opportunities."
        },
        {
            q: "Where does MandiGate deliver fruits and vegetables?",
            a: "We currently deliver across Ghaziabad, Noida, Greater Noida, and nearby NCR areas, and are expanding to more cities soon."
        },
        {
            q: "Are the fruits and vegetables organic?",
            a: "Yes, MandiGate sources organic and chemical-free produce directly from trusted local farmers across India."
        },
        {
            q: "How does MandiGate ensure freshness and quality?",
            a: "Every product goes through strict quality checks and is delivered within 24 hours of harvest to guarantee freshness."
        },
        {
            q: "How does MandiGate support local farmers?",
            a: "We directly procure produce from farmers at fair prices, helping them earn better income and reduce dependency on middlemen."
        },
        {
            q: "How can I contact customer support?",
            a: "You can reach our support team at 9220638055 — we’re happy to help!"
        }
    ];

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', gap: 4, alignItems: 'stretch', justifyContent: 'center', flexWrap: 'wrap' }}>
                {/* Left: Title with decorative icon */}
                <Box sx={{ flex: '0 0 320px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 2, p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="h4" fontWeight="bold" textAlign="center" sx={{ lineHeight: 1 }}>{"Frequently\nAsked Questions"}</Typography>
                    </Box>
                </Box>

                {/* Right: Questions */}
                <Box sx={{ flex: '1 1 480px', minWidth: 320 }}>
                    {faqs.map((item, idx) => (
                        <Accordion
                            key={idx}
                            disableGutters
                            elevation={0}
                            sx={(theme) => ({
                                borderBottom: '1px solid rgba(0,0,0,0.08)',
                                transition: 'box-shadow 220ms ease, background-color 220ms ease',
                                '&:hover': {
                                    boxShadow: '0 10px 30px rgba(2,109,11,0.06)'
                                },
                                '&.Mui-expanded': {
                                    backgroundColor: 'rgba(2,109,11,0.04)'
                                }
                            })}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                sx={(theme) => ({
                                    transition: 'background-color 200ms ease',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    '&:hover': { backgroundColor: 'rgba(2,109,11,0.06)' },
                                    '& .MuiAccordionSummary-content': { alignItems: 'center' },
                                    '& .MuiAccordionSummary-expandIconWrapper': { transition: 'transform 200ms ease' },
                                    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': { transform: 'rotate(180deg)', color: '#026D0B' },
                                    '& .question-dot': { color: 'rgba(2,109,11,0.45)', mr: 1.5 },
                                    '&.Mui-expanded .question-dot': { color: '#026D0B' },
                                    [theme.breakpoints.down('sm')]: {
                                        '&:hover': { backgroundColor: 'rgba(2,109,11,0.05)' }
                                    }
                                })}
                            >

                                <Typography
                                    variant="subtitle1"
                                    fontWeight="medium"
                                    sx={(theme) => ({
                                        fontSize: `calc(${theme.typography.subtitle1.fontSize} + 2px)`,
                                        transition: 'color 180ms ease, transform 180ms ease',
                                        '.MuiAccordion-root:hover &': { transform: 'scale(1.02)' },
                                        '.Mui-expanded &': { color: '#026D0B' }
                                    })}
                                >
                                    {item.q}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography variant="body1" sx={{ textAlign: 'left' }}>{item.a}</Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default FAQ;
